import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EmbedSetupContentSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="text" width="80%" height={32} />
      <Skeleton variant="rounded" width="100%" height={560} />
    </Styles.Container>
  )
}

export default EmbedSetupContentSkeleton
